var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJudgeHammer3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19.14,
    viewBox: "0 0 22 19.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.7,20.3a.87.87,0,0,1-.9.5H10.3a.79.79,0,0,1-.8-.5.88.88,0,0,1,.1-.7c.5-.6,1-1.3,1.5-1.9a3.37,3.37,0,0,1,2.6-1.2h6a3.4,3.4,0,0,1,3,1.7c.3.5.6,1.1.9,1.6A1.34,1.34,0,0,1,23.7,20.3Zm-2-.9A2.15,2.15,0,0,0,19.8,18H13.7a2.47,2.47,0,0,0-2,1.4Z",
    transform: "translate(-1.7 -1.66)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,11.2c-.9.5-1.8.9-2.7,1.4-1.7.9-3.5,1.8-5.2,2.7a2.66,2.66,0,0,1-3.9-2.5,2.55,2.55,0,0,1,1.8-2.4c2-.8,4-1.5,6-2.3.7-.3,1.5-.6,2.3-.9a2.09,2.09,0,0,0-.4-.6,2.08,2.08,0,0,1,.5-3.3l3.3-1.5A2.07,2.07,0,0,1,18,3.7a.6.6,0,0,0,.1.4c.6,1.5,1.3,2.9,2,4.4.1.1.1.2.2.3a2,2,0,0,1-.5,3.3l-3.3,1.5a2.06,2.06,0,0,1-2.8-1.8A.85.85,0,0,1,13.5,11.2ZM12.3,8.6c-.1,0-.1.1-.2.1-1.7.6-3.3,1.3-5,1.9-1.1.4-2.2.8-3.2,1.2A1.44,1.44,0,0,0,3,12.9a1.43,1.43,0,0,0,.6,1.2A1.21,1.21,0,0,0,5,14l6.9-3.6c.3-.2.6-.3.9-.5A11.22,11.22,0,0,0,12.3,8.6Zm4.5-3.5c-1.3.6-2.6,1.1-3.8,1.7.6,1.3,1.1,2.6,1.7,3.8,1.3-.6,2.6-1.1,3.8-1.7C18,7.6,17.4,6.4,16.8,5.1Zm-4.6.5C13.6,5,15,4.3,16.5,3.7a.7.7,0,0,0-.9-.4c-1,.5-2.1.9-3.1,1.4A.59.59,0,0,0,12.2,5.6Zm7.1,4.5c-1.4.6-2.8,1.3-4.2,1.9a.7.7,0,0,0,.9.4c1-.4,2-.9,3.1-1.4C19.4,10.9,19.5,10.5,19.3,10.1Z",
    transform: "translate(-1.7 -1.66)",
    fill: "{props.color}"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.7 -1.66)",
    fill: "{props.color}",
    stroke: "{props.color}\\xCF",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.7 -1.66)",
    fill: "none",
    stroke: "{props.color}\\xCF",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudgeHammer3);
export default __webpack_public_path__ + "static/media/judge-hammer3.b962f48f056eab1dd7a22a8fd70058c6.svg";
export { ForwardRef as ReactComponent };